import { Component } from '@angular/core';

@Component({
    selector: 'app-progress-bar-indeterminate-example',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.css'],
    standalone: false
})
export class ProgressBarIndeterminateExampleComponent {}
